// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "small[data-v-08014533] {\n  color: #35393e;\n}\n", ""]);
// Exports
module.exports = exports;
